import { AxiosService } from './axiosService';

export class MappingTreeService extends AxiosService {
    // Omitting componentId returns the mapping-tree roots.
    async getMappingRoots() {
        return this.getMappingChildren();
    }

    async getMappingChildren(componentId) {
        try {
            const params = {};
            if (componentId != null) params.componentId = componentId;
            const { data } = await this.axios.get('/MappingTree', { params });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async addMappingRoot(componentId) {
        try {
            const { data } = await this.axios.post('/mappingtree/root', { componentId });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async addMappingChild(parentId, childId) {
        try {
            const { data } = await this.axios.post('/mappingtree/child', {
                parentComponentId: parentId,
                childComponentId: childId,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async removeMappingRoot(componentId) {
        try {
            const { data } = await this.axios.delete('/mappingtree/root', {
                params: { componentId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async removeMappingChild(parentId, childId) {
        try {
            const { data } = await this.axios.delete('/mappingtree/child', {
                params: { parentComponentId: parentId, childComponentId: childId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async moveMappingNode({ childId, fromParentId = null, toParentId = null }) {
        try {
            const { data } = await this.axios.post('/mappingtree/move', {
                childComponentId: childId,
                fromParentId,
                toParentId,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }
}

export const mappingTreeService = new MappingTreeService();
